import React from 'react';
import ProductNavItem from './ProductNavItem';
import PropTypes from 'prop-types';
import { get } from 'lodash';

class ProductBundleNav extends React.Component {
  render() {
    const { selectedNavItem, sticky, onClickNavItem, bundles } = this.props;
    return (
      <div className="covid-nav">
        <div className="covid-nav-interior-sticky">
          {Object.keys(bundles).map(bundle => {
            return (
              <ProductNavItem
                key={bundle}
                onClickNavItem={onClickNavItem}
                bundleId={bundle}
                selectedNavItem={selectedNavItem}
                sticky={sticky}
                bundles={bundles}
                isShowingSupportSection={get(bundles, 'raiseFinancialSupport')}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

ProductBundleNav.propTypes = {
  selectedNavItem: PropTypes.string,
  sticky: PropTypes.bool,
  onClickNavItem: PropTypes.func,
  bundles: PropTypes.object
};

export default ProductBundleNav;
